import { ref } from 'vue'

// toasts array holds objects: { id, message, type, show, action?: { label, callback } }
const toasts = ref([])

export function useToast() {
  const removeToast = (id) => {
    const index = toasts.value.findIndex((t) => t.id === id)
    if (index !== -1) toasts.value.splice(index, 1)
  }

  const showToast = (
    message,
    type = 'info',
    duration = 3000,
    action = null // { label: string, callback: function }
  ) => {
    const id = Date.now() + Math.floor(Math.random() * 1000)
    const toast = {
      id,
      message,
      type,
      show: true,
    }

    if (action && typeof action === 'object' && action.label && typeof action.callback === 'function') {
      toast.action = action
    }

    toasts.value.push(toast)

    if (duration > 0) {
      setTimeout(() => removeToast(id), duration)
    }

    return id
  }

  const toast = {
    success: (message, duration = 3000, action = null) =>
      showToast(message, 'success', duration, action),
    error: (message, duration = 5000, action = null) => showToast(message, 'error', duration, action),
    info: (message, duration = 3000, action = null) => showToast(message, 'info', duration, action),
    warning: (message, duration = 4000, action = null) =>
      showToast(message, 'warning', duration, action),
  }

  return {
    toasts,
    showToast,
    removeToast,
    toast,
  }
}
